/***
 * 帆软打印
 */
import { pgMessage } from '../../message/index'
export function fineReport({ compileDatas, batchPrint, extendData, printTemplate }) {
  if (!batchPrint) {
    const viewUrl = compileDatas[0].url
    const win = window.open(viewUrl)
    if (!win || !win.location) {
      pgMessage.error('被浏览器拦截了，请设置浏览器允许弹出窗口！')
    }
  } else {
    const reportlets = compileDatas.map((data) => {
      const { viewlet, other } = data.urlParam
      return {
        ...other,
        reportlet: viewlet,
        ...extendData?.findBi?.skipParamter,
      }
    })

    const conf = {
      config: {
        pageType: 0,
        ...extendData.findBi.batchPrintConf,
        printUrl:
          printTemplate.url.indexOf('?') !== -1
            ? printTemplate.url.split('?')[0]
            : printTemplate.url,
        data: {
          reportlets: JSON.stringify(reportlets),
        },
      },
      batchPrintJs: extendData.findBi.batchPrintJs,
      findBiUrl: compileDatas[0].compileSource.GLOBAL.findBiUrl,
    }

    //加载css
    // var head = document.getElementsByTagName('head')[0];
    // var link = document.createElement('link');
    // var tempCss = conf.batchPrintCss;
    // if (tempCss.indexOf('http://') == -1 && tempCss.indexOf('https://') == -1 && conf.findBiUrl) {
    //     tempCss = conf.findBiUrl + tempCss;
    // }
    // link.href = tempCss;
    // link.rel = 'stylesheet';
    // link.type = 'text/css';
    // head.appendChild(link);
    //加载js并调用打印
    if (window.FR) {
      conf.config.data.reportlets = window.FR.cjkEncode(conf.config.data.reportlets)
      window.FR.doURLPrint(conf.config)
    } else {
      var script = document.createElement('script')
      script.type = 'text/javascript'
      var temp = conf.batchPrintJs
      if (temp.indexOf('http://') == -1 && temp.indexOf('https://') == -1 && conf.findBiUrl) {
        temp = conf.findBiUrl + temp
      }
      script.src = temp
      script.onload = function () {
        conf.config.data.reportlets = window.FR.cjkEncode(conf.config.data.reportlets)
        window.FR.doURLPrint(conf.config)
      }
      document.getElementsByTagName('head')[0].appendChild(script)
    }
  }
}
